module.exports = __webpack_public_path__ + "static/apple-touch-333ba10f825c24e2a38c6d4638bb2517.png";